export default class CongestionLevel {
  APMAC?: string
  ts?: Date
  level?: number
  stayCount?: number
  nonstayCount?: number
  border1?: number
  border2?: number

  constructor(attrs = {}) {
    Object.assign(this, attrs)
  }
}